import { ShiftDetailWorker } from '../api/types';

/**
 * How many of the panel's roster rows are still ON the shift (GRAVY-10851).
 *
 * The Hired section's list and its count answer two different questions, and
 * the panel had been using one number for both. The LIST is deliberately
 * additive: GRAVY-10342 put dropped and ops-removed workers back on it, each
 * carrying its own chip, because "who was on this shift and walked" is a
 * question the panel is open to answer and a row that simply vanishes reads as
 * never staffed. The COUNT is the staffing level — shift 115885 read
 * "Hired (10)" over six people actually working it.
 *
 * Only `dropped` and `removed` are excluded. Every other state — confirmed,
 * in_progress, completed, approved, paid, expired — is a normal transition of
 * somebody who IS on the roster; excluding those is the exact trap GRAVY-10326
 * fixed, where a finished shift reported nobody hired. A no-show stays counted
 * too: they were staffed and did not turn up, which is why the chip exists.
 *
 * This deliberately derives the count from the rows on screen rather than
 * reading the payload's `hired_count`. Both mean `job_workers.active`, but
 * `hired_count` is the denormalized `jobs.hired_workers_count` column, so a
 * stale counter would put the heading back out of step with the list under it —
 * which is the whole complaint.
 */
const OFF_ROSTER_STATUSES = new Set([
  'dropped',
  'removed',
  // The underlying column is `dismissed_at`, and parts of the codebase name the
  // state after it. The panel's payload says 'removed'; accepting both costs
  // nothing and fails safe if that ever changes.
  'dismissed',
]);

export const isOffRoster = (worker: ShiftDetailWorker): boolean =>
  worker.dropped === true ||
  worker.removed === true ||
  OFF_ROSTER_STATUSES.has((worker.status ?? '').toLowerCase());

export const hiredRosterCount = (workers: ShiftDetailWorker[]): number =>
  workers.filter((w) => !isOffRoster(w)).length;

export default hiredRosterCount;
